import './index.scss';



/** WEBPACK FOOTER **
 ** ./src/NewsContent/index.js
 **/